import RankEighteen from '@assets/icons/rank-eighteen.svg'
import { Icon } from './Icon'

export const RankEighteenIcon = Icon(RankEighteen)
